/*  ========================================================================
    # Scripts - Header (Mobile)
    ========================================================================  */

/**
 * Script that handles opening/closing the mobile menu
 */

const HeaderMobile = {
  cfg: {
    menuButton: document.querySelector('.c-header-mobile__menu-button'),
    menuItems: document.querySelectorAll('.c-header-mobile__menu a'),
    header: document.querySelector('.c-header-mobile'),
    body: document.querySelector('body')
  },

  /**
   * Initialize.
   */
  init() {
    this.cfg.menuButton.addEventListener('click', event => {
      event.stopPropagation();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.cfg.header.toggleAttribute('data-opened');
      this.cfg.body.toggleAttribute('data-fixed');
    });
    this.cfg.menuItems.forEach(item =>
      item.addEventListener('click', () => {
        this.cfg.header.removeAttribute('data-opened');
        this.cfg.body.removeAttribute('data-fixed');
      })
    );
  }
};

export default HeaderMobile;
